/** Light auth shell — matches the public landing page instead of a dark blue wall. */
export const AUTH_PAGE_BG_SX = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: `
    radial-gradient(900px 420px at 10% -10%, rgba(37, 99, 235, 0.12), transparent 55%),
    linear-gradient(180deg, #EEF4FF 0%, #F8FAFC 50%, #FFFFFF 100%)
  `,
  p: 2,
};
